import { userService } from './userService';

// API Configuration
const PROD_API_BASE = 'https://5z9vmw0tg6.execute-api.eu-north-1.amazonaws.com/production';
const DEV_API_BASE = 'https://9vnb05of2j.execute-api.eu-north-1.amazonaws.com/development';

// Auto-select API by environment
const API_BASE_URL = (() => {
  const fromEnv = process.env.REACT_APP_API_URL;
  if (fromEnv && fromEnv.trim().length > 0) return fromEnv;
  if (typeof window !== 'undefined') {
    const host = window.location.host || '';
    const hostname = window.location.hostname || '';
    const isLocalhost = hostname === 'localhost' || hostname === '127.0.0.1';
    const isDevSite = host.includes('saas-application-dev.s3-website.eu-north-1.amazonaws.com');
    if (isLocalhost || isDevSite) return DEV_API_BASE;
  }
  return PROD_API_BASE;
})();

// Using centralized userService.getAuthToken() instead of duplicate code

const getAuthHeaders = async () => {
  const jwtToken = await userService.getAuthToken();
  
  return {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${jwtToken}`,
  };
};

interface DocumentPreviewResponse {
  document_id: string;
  filename: string;
  mime_type: string;
  file_size: number;
  preview_url: string;
  expires_in: number;
  ticket_uuid?: string;
  preview_supported: boolean;
}

class DocumentService {
  /**
   * Get file preview URL and metadata
   */
  async getFilePreview(documentId: string): Promise<DocumentPreviewResponse> {
    try {
      console.log(`[DocumentService] Getting preview for document: ${documentId}`);
      
      const headers = await getAuthHeaders();
      
      const response = await fetch(`${API_BASE_URL}/documents/${documentId}/preview`, {
        method: 'GET',
        headers
      });

      if (!response.ok) {
        const errorText = await response.text();
        console.error('Preview API error:', {
          status: response.status,
          statusText: response.statusText,
          body: errorText
        });
        throw new Error(`Failed to get file preview: ${response.status} ${errorText}`);
      }

      const data = await response.json();
      console.log(`[DocumentService] Preview retrieved for: ${data.filename}`);
      
      return data;
    } catch (error) {
      console.error('[DocumentService] Error getting file preview:', error);
      throw error;
    }
  }
}

// Export singleton instance
export const documentService = new DocumentService(); 